module.exports = __webpack_public_path__ + "static/media/card3.f374612b.png";